/**
 * Image Block Configuration
 *
 * Registry config for the embedded image block type.
 */

import { Image as ImageIcon } from "lucide-react";
import { ImageBlock } from "@/canvas/components/blocks/ImageBlock";
import type { BlockConfig } from "../types";

export const imageBlockConfig: BlockConfig<"image"> = {
  type: "image",
  component: ImageBlock,
  icon: ImageIcon,
  iconClassName: "text-violet-500",
  label: "canvas.blockTypes.image",
  defaultContent: () => ({ storagePath: "", altText: "", caption: "" }),
};
